export default {
  'component.bids.title': 'Bud',
  'component.bids.description':
    'Følg budrunden din live! I tillegg vil megleren følge deg opp personlig.',
  'component.bids.budjournal': 'Budjournal',
  'component.bids.active': 'Budoversikt',
  'component.bids.history': 'Historie',
};
